import AppRouter from './routing/app-router';
import Providers from './providers';
import { Suspense } from 'react';

function App() {
  return (
    <Suspense>
      <Providers>
        <AppRouter />
      </Providers>
    </Suspense>
  );
}

export default App;
